const frontendURL = '/cat/auditor/';
const backendURL = '/api/references/refauditor/';
const name = 'Підрозділи (Пічники)';

const instance = {
  frontendURL,
  backendURL,
  name,
  useHierarchyPagination: true,
};
export default instance;
